import React  from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './CookiePolicy.css';

const CookiePolicy = () => {
  const EFFECTIVE_DATE = '10th Feb, 2026';
  const LAST_UPDATED = '10th Feb, 2026';
  const SUPPORT_EMAIL = 'privacy@shipmnts.com';

  return (
    <section className="cookie-policy-container first-section">
      <Helmet>
        <title>Cookie Policy | Shipmnts</title>
        <meta
          name="description"
          content="Cookie Policy for Shipmnts.com - Learn how we use cookies and similar technologies."
        />
      </Helmet>

      <div className="cookie-policy-content">
        <h1 className="policy-title">Cookie Policy</h1>

        <div className="effective-dates">
          <p>
            <strong>Effective Date:</strong> {EFFECTIVE_DATE}
          </p>
          <p>
            <strong>Last Updated:</strong> {LAST_UPDATED}
          </p>
        </div>

        <p className="intro-text">
          This Cookie Policy explains how Shipmnts.com uses cookies and similar technologies.
        </p>

        {/* Section 1 */}
        <div className="policy-section">
          <h2>1. What Are Cookies</h2>
          <p>
            Cookies are small text files stored on your device when you visit a website. They help
            websites remember your preferences and improve your browsing experience.
          </p>
        </div>

        {/* Section 2 */}
        <div className="policy-section">
          <h2>2. Types of Cookies We Use</h2>
          <ul>
            <li>
              <strong>Strictly Necessary Cookies</strong> – Essential for platform functionality. These cookies enable core features like security, network management, and accessibility.
            </li>
            <li>
              <strong>Performance & Analytics Cookies</strong> – Help us analyse usage patterns and improve platform performance. They collect anonymous data about how visitors use our site.
            </li>
            <li>
              <strong>Functional Cookies</strong> – Remember your preferences such as language, region, and display settings to provide a personalized experience.
            </li>
            <li>
              <strong>Security Cookies</strong> – Protect your account and sessions by detecting authentication abuse and preventing fraudulent use of login credentials.
            </li>
          </ul>
        </div>

        {/* Section 3 */}
        <div className="policy-section">
          <h2>3. Third-Party Cookies</h2>
          <p>
            We may use third-party tools such as analytics and monitoring services that place
            cookies subject to their own privacy policies. These include:
          </p>
          <ul>
            <li>Google Analytics – for traffic analysis</li>
            <li>Performance monitoring tools</li>
            <li>Error tracking services</li>
          </ul>
        </div>

        {/* Section 4 */}
        <div className="policy-section">
          <h2>4. Managing Cookies</h2>
          <p>
            You can control cookies via browser settings. Most browsers allow you to:
          </p>
          <ul>
            <li>View what cookies are stored</li>
            <li>Delete individual or all cookies</li>
            <li>Block third-party cookies</li>
            <li>Block cookies from specific sites</li>
            <li>Block all cookies</li>
          </ul>
          <p className="note">
            <strong>Note:</strong> Disabling cookies may limit certain functionality of the platform.
          </p>
        </div>

        {/* Section 5 */}
        <div className="policy-section">
          <h2>5. Updates</h2>
          <p>
            This Cookie Policy may be updated periodically to reflect changes in our practices or
            for other operational, legal, or regulatory reasons. We will notify you of any material
            changes by updating the "Last Updated" date at the top of this policy.
          </p>
        </div>

        {/* Section 6 */}
        <div className="policy-section contact-section">
          <h2>6. Contact</h2>
          <p>For cookie or privacy-related questions, contact:</p>
          <div className="contact-card">
            <p className="company-name">Logistixian Technologies Private Limited</p>
            <p>
              <strong>Email:</strong>{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </p>
          </div>
        </div>

        {/* Related Links */}
        <div className="policy-section related-links">
          <h2>Related Policies</h2>
          <div className="links-container">
            <Link to="/privacy-policy" className="policy-link">
              Privacy Policy
            </Link>
            <Link to="/terms-of-services" className="policy-link">
              Terms of Service
            </Link>
          </div>
        </div>

        
      </div>
    </section>
  );
};

export default CookiePolicy;
